import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslations } from 'next-intl';
import {
  MyEquipmentTabs,
  MyEquipmentNickname,
  MyEquipmentToggleShareButton,
  MyEquipmentInfoToolTip,
  Conditional
} from 'components/pcc-components';
import {
  FORM_FIELD_NICK_NAME,
  NOTIFY_DEALER,
  TAB_INDEX_SERIAL
} from 'components/my-equipment/constants';
import {
  hasHtmlInjectionTags,
  replaceTokensInString
} from '@cat-ecom/common/utils/stringUtils';
import { BlocksTabChange } from '@blocks-web-components/events/blocks-tab-change';
import { AddEquipmentFootNote } from '../add-equipment-foot-note';
import { AddEquipmentByModel } from '../add-equipment-form/add-equipment-by-model/add-equipment-by-model';
import { AddEquipmentBySerial } from '../add-equipment-form/add-equipment-by-serial/add-equipment-by-serial';
import { HTML_SPECIAL_CHAR_ERROR } from '@cat-ecom/common/utils/constants';
import { PCC_MY_EQUIPMENT_PAGE } from 'constants/analyticsConstants';

const EquipmentWidgetPanel = ({
  handleYesClickedDuplicateBanner,
  showNotifyDealer,
  showFootNote = false,
  formLocation = PCC_MY_EQUIPMENT_PAGE
}) => {
  const t = useTranslations();
  const form = useFormContext();
  const watchNotifyDealer = form.watch(NOTIFY_DEALER);
  const [activeIndex, setActiveIndex] = useState(TAB_INDEX_SERIAL);

  const onTabChange = (e: BlocksTabChange) => {
    setActiveIndex(e.detail.activeTabIndex);
    form.reset();
  };

  const handleNotifyDealerToggleChange = () => {
    form.setValue(NOTIFY_DEALER, !watchNotifyDealer);
  };

  return (
    <>
      <MyEquipmentTabs activeIndex={activeIndex} onBlTabChange={onTabChange}>
        <AddEquipmentBySerial
          handleYesClickedDuplicateBanner={handleYesClickedDuplicateBanner}
          showBackButton
          isChild
          formLocation={formLocation}
        />
        <AddEquipmentByModel
          handleYesClickedDuplicateBanner={handleYesClickedDuplicateBanner}
          showBackButton
          isChild
          formLocation={formLocation}
        />
      </MyEquipmentTabs>
      <MyEquipmentNickname
        placeholder={t('MEQ_NICKNAME')}
        name={FORM_FIELD_NICK_NAME}
        rules={{
          validate: {
            validateNickName: (value) => {
              return hasHtmlInjectionTags(
                value,
                replaceTokensInString(
                  t('ADD_INV_CHAR_NEW_FIELD_WARNING', {
                    1: HTML_SPECIAL_CHAR_ERROR
                  })
                )
              );
            }
          }
        }}
      />
      <Conditional test={showNotifyDealer && activeIndex === TAB_INDEX_SERIAL}>
        <div className="pt-3 d-flex" data-testid="share-toggle">
          <MyEquipmentToggleShareButton
            handleToggleChange={handleNotifyDealerToggleChange}
            text={t('MEQ_ADD_NOTIFICATION1')}
            checked={watchNotifyDealer}
          />
          <MyEquipmentInfoToolTip
            label={t('MEQ_ADD_NOTIFICATION3')}
            className="pt-1"
            ariaLabel={t('MEQ_ADD_NOTIFICATION3')}
          />
        </div>
      </Conditional>
      <Conditional test={showFootNote}>
        <AddEquipmentFootNote />
      </Conditional>
    </>
  );
};

export default EquipmentWidgetPanel;
